import Defs from '../../../../includes/primitives/colorDefs'

export default {
  data: () => ({

    canvasForms: null,
    rawData:  null,

    donut:  null,
    legends:  null,
    gauge:  null,
    icon:  null,

    angle: {size: 0, start: 0, end: 0},
    pieSectors: [],
    
  }),

  computed: {
    ready2draw() {
      return (
        this.DataItems.length > 0 &&
        Object.keys(this.Canvas).length > 0
      )
    },
  },

  methods: {

    set_Gradients() {
      this.gmx_radialShadow()
      this.gmx_Color2Sets()
    },
  
  }
}